import { defineComponent as _defineComponent } from 'vue'
import { createVNode as _createVNode, createElementVNode as _createElementVNode, unref as _unref, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, normalizeStyle as _normalizeStyle, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-476e4978"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "home-container" }
const _hoisted_2 = { class: "carousel-container" }
const _hoisted_3 = { class: "company-profile global-container" }
const _hoisted_4 = { class: "development-title" }
const _hoisted_5 = { class: "brief-image" }
const _hoisted_6 = ["src"]
const _hoisted_7 = { class: "experience-container" }
const _hoisted_8 = { class: "num" }
const _hoisted_9 = { class: "title" }
const _hoisted_10 = { class: "physical-container" }
const _hoisted_11 = { class: "development-container" }
const _hoisted_12 = { class: "development-title" }
const _hoisted_13 = { class: "development-time" }
const _hoisted_14 = { class: "date" }
const _hoisted_15 = { class: "title" }
const _hoisted_16 = { class: "products-container" }
const _hoisted_17 = {
  class: "development-title",
  style: { marginTop: '100px' }
}
const _hoisted_18 = { class: "introduce-item" }
const _hoisted_19 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "banner-container" }, [
  /*#__PURE__*/_createElementVNode("p", null, "携手· 市面 首款 智能鱼缸"),
  /*#__PURE__*/_createElementVNode("p", null, "同创· 水族 智能 领导品牌")
], -1))
const _hoisted_20 = { class: "footerInfo-contact" }

import Carousel from "../components/Carousel.vue";
import FooterInfo from "../components/FooterInfo.vue";
import testBnner from "../components/testBnner.vue";
import GenericTitle from "../components/GenericTitle.vue";
import { reactive, ref , getCurrentInstance} from "vue";
const IntroduChinese = "企业简介";
const IntroduEnglish = "About us";
const develuChinese = "发展历程";
const develuEnglish = "History";
const prdChinese = "产品与服务";
const prdEnglish = "Introduction";

export default /*#__PURE__*/_defineComponent({
  __name: 'Home',
  setup(__props) {

const instance = getCurrentInstance();
const baseUrl = instance?.appContext.config.globalProperties.$baseUrl;
const homeCarData = reactive([
  {
    image: baseUrl + "home/Maskgroup@1.png",
    altText: "Image1",
    describe: {
      title: "蓝得智能水族",
      introduction:
          "蓝得智能水族，智慧引领水族新时代！创新科技，卓越养殖体验。选择蓝得，与智能共创水族新篇章！",
    },
  },
  {
    image: baseUrl + "home/Maskgroup@2.png",
    altText: "Image2",
    describe: {
      title: "蓝得智慧鱼池",
      introduction:
          "蓝得智能鱼池是一款以科技创新为驱动，致力于为消费者提供智能化、便捷化的鱼池养护体验的高科技产品。",
    },
  },
  {
    image: baseUrl + "home/Group632@3x.png",
    altText: "Image3",
    describe: {
      title: "蓝得智慧配件",
      introduction:
          "以研发制造智能养护系统为主的科技创新企业，致力于为客户打造极致的轻松养鱼体验，实现水族、宠物及人类辅助养护的智慧未来。",
    },
  },
]);
const introductionData = reactive([
  {
    image: baseUrl + "home/products1.png", // 替换为baseUrl路径
    describe: {
      title: "智能化科技",
      introduction:
          "依托智能系统、创新技术等开发， 打造轻松科学养鱼的产品， 彻底解决客户痛点",
    },
  },
  {
    image: baseUrl + "home/products2.png", // 替换为baseUrl路径
    describe: {
      title: "一站式生态",
      introduction: "共建水族行业的全生态资源， 赋能轻松愉悦养鱼的一站式服务",
    },
  },
  {
    image: baseUrl + "home/products3.png", // 替换为baseUrl路径
    describe: {
      title: "大数据服务",
      introduction:
          "推进水族行业大数据， 以云计算提供市场分析、精准需求和定向开发， 及营销活动",
    },
  },
]);
const aboutData = ref([
  {
    num: "5",
    title: "自营体验中心",
  },
  {
    num: "15",
    title: "官方经销商",
  },
  {
    num: "200",
    title: "个人代理商",
  },
  {
    num: "100,000+",
    title: "注册用户",
  },
]);
const historyData = ref([
  {
    date: "2020.08",
    title: "项目启动",
  },
  {
    date: "2021.01",
    title: "公司成立",
  },
  {
    date: "2021.05",
    title: "智能养护系统验证",
  },
  {
    date: "2022.03",
    title: "首批客户交付",
  },
  {
    date: "2022.10",
    title: "云计算管理系统",
  },
  {
    date: "2023.06",
    title: "天使轮投资",
  },
  {
    date: "2024.01",
    title: "受华为全屋智能鸿蒙生态 认证",
  },
]);
const boxStyle = (index: number) => {
  return {
    borderRight:
      (index + 1) % 4 === 0 || index === historyData.value.length - 1
        ? "none"
        : "2px solid #e4e6e8",
  };
};

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createVNode(Carousel, { carouselData: homeCarData }, null, 8, ["carouselData"])
    ]),
    _createElementVNode("div", _hoisted_3, [
      _createElementVNode("div", _hoisted_4, [
        _createVNode(GenericTitle, {
          chineseText: IntroduChinese,
          englishText: IntroduEnglish
        })
      ]),
      _createElementVNode("div", _hoisted_5, [
        _createElementVNode("img", {
          src: _unref(baseUrl) + 'home/Group 518@2x.png',
          alt: "Image"
        }, null, 8, _hoisted_6)
      ])
    ]),
    _createElementVNode("div", _hoisted_7, [
      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(aboutData.value, (exp, index) => {
        return (_openBlock(), _createElementBlock("div", {
          class: "experience-item",
          key: index
        }, [
          _createElementVNode("div", _hoisted_8, _toDisplayString(exp.num), 1),
          _createElementVNode("div", _hoisted_9, _toDisplayString(exp.title), 1)
        ]))
      }), 128))
    ]),
    _createElementVNode("div", _hoisted_10, [
      _createVNode(testBnner)
    ]),
    _createElementVNode("div", _hoisted_11, [
      _createElementVNode("div", _hoisted_12, [
        _createVNode(GenericTitle, {
          chineseText: develuChinese,
          englishText: develuEnglish
        })
      ]),
      _createElementVNode("div", _hoisted_13, [
        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(historyData.value, (dev, index) => {
          return (_openBlock(), _createElementBlock("div", {
            class: "itme",
            key: index,
            style: _normalizeStyle(boxStyle(index))
          }, [
            _createElementVNode("div", _hoisted_14, _toDisplayString(dev.date), 1),
            _createElementVNode("div", _hoisted_15, _toDisplayString(dev.title), 1)
          ], 4))
        }), 128))
      ])
    ]),
    _createElementVNode("div", _hoisted_16, [
      _createElementVNode("div", _hoisted_17, [
        _createVNode(GenericTitle, {
          chineseText: prdChinese,
          englishText: prdEnglish
        })
      ]),
      _createElementVNode("div", _hoisted_18, [
        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(introductionData, (item, index) => {
          return (_openBlock(), _createElementBlock("div", {
            class: "introduce-container",
            key: index,
            style: _normalizeStyle({ backgroundImage: `url(${item.image})` })
          }, [
            _createElementVNode("h2", null, _toDisplayString(item.describe.title), 1),
            _createElementVNode("p", null, _toDisplayString(item.describe.introduction), 1)
          ], 4))
        }), 128))
      ])
    ]),
    _hoisted_19,
    _createElementVNode("div", _hoisted_20, [
      _createVNode(FooterInfo)
    ])
  ]))
}
}

})